import React, { useState, useEffect } from "react";
import toast, { Toaster } from "react-hot-toast";
import { requestForToken, onMessageListener } from "./firebase";
import io from "socket.io-client";
import ApiConfig from "src/apiconfig/apiconfig";

import { makeStyles, Box, Typography } from "@material-ui/core";
import Snackbar from "@material-ui/core/Snackbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import DoneIcon from "@material-ui/icons/Done";
import { useHistory } from "react-router-dom";
import { localeFunction } from "src/utils/index";

import NitificationPopUp from "src/component/NotificationAlertPopUp";

const useStyles = makeStyles((theme) => ({
  acceptBtn: {
    fontSize: "14px",
    color: "green",
  },
  rejectBtn: {
    fontSize: "14px",
    color: "red",
  },
}));

const Notification = () => {
  const [open, setOpen] = useState(false);
  const [notification, setNotification] = useState({ title: "", body: "" });
  const [notificationData, setNotificationData] = useState();

  const notify = () => {
    return <ToastDisplay />;
  };

  // Placeholder for notification payload (real call payload arrives via socket/FCM at runtime).
  const msgDetails = {
    data: {},
    notification: {},
  };

  function ToastDisplay() {
    return (
      <>
        <NitificationPopUp
          data={notificationData}
          notification={notification}
          open={open}
          setOpen={setOpen}
        />
      </>
    );
  }

  // useEffect(() => {
  //   setNotificationData(msgDetails.data);
  //   setNotification(msgDetails.notification);
  //   setOpen(true);
  //   notify();
  // }, []);

  useEffect(() => {
    if (notification?.title) {
      ToastDisplay();
    }
  }, [notification]);

  requestForToken();

  // Setup Socket.io connection for incoming calls
  useEffect(() => {
    let socket = null;
    
    const connectSocket = () => {
      const userId = localStorage.getItem("userId");
      const userToken = localStorage.getItem("userToken");
      
      if (!userId || !userToken) {

        return null; // Don't connect if user not logged in
      }

      // Get socket URL from ApiConfig (uses staging/production URL, not localhost)
      const socketUrl = ApiConfig.socketUrl || "https://api.kuvuma.com";

      socket = io(socketUrl, {
        transports: ["polling"], // Use polling only to avoid WebSocket conflict
        reconnection: true,
        reconnectionDelay: 1000,
        reconnectionAttempts: 5,
        forceNew: false,
        upgrade: false, // Disable upgrade to WebSocket
      });

      // Emit user connection to identify user
      socket.on("connect", () => {


        socket.emit("userConnected", {
          userId: userId,
          token: userToken,
        });
      });

      // Listen for incoming call notifications
      socket.on("incomingCall", (callData) => {

        if (callData && callData.notification && callData.callData) {
          setOpen(true);
          setNotification({
            title: callData.notification.title || "Incoming Call",
            body: callData.notification.body || "Someone is calling...",
          });
          setNotificationData({
            ...callData.callData,
            name: callData.sender?.userName || "Unknown",
            profilePic: callData.sender?.profilePic || "",
            callType: callData.callType || "Voice",
          });
        }
      });

      // Ticket screens listen on window so they can share this single socket.
      socket.on("ticketUpdated", (data) => {
        window.dispatchEvent(new CustomEvent("ticketUpdated", { detail: data }));
      });

      socket.on("disconnect", () => {

      });

      socket.on("connect_error", (error) => {
        console.error("❌ Socket.io connection error:", error);
      });

      return socket;
    };

    // Connect immediately if user is logged in
    socket = connectSocket();

    // Also listen for storage changes (when user logs in)
    const handleStorageChange = () => {
      const userId = localStorage.getItem("userId");
      const userToken = localStorage.getItem("userToken");
      
      if (userId && userToken && (!socket || !socket.connected)) {

        if (socket) {
          socket.disconnect();
        }
        socket = connectSocket();
      }
    };

    // Listen for storage events (when user logs in from another tab)
    window.addEventListener("storage", handleStorageChange);

    // Also check periodically if user logged in (for same-tab login)
    // But only check a few times to avoid infinite loops
    let checkCount = 0;
    const maxChecks = 5; // Only check 5 times (10 seconds total)
    const checkInterval = setInterval(() => {
      checkCount++;
      if (checkCount > maxChecks) {
        clearInterval(checkInterval);
        return;
      }
      
      const userId = localStorage.getItem("userId");
      const userToken = localStorage.getItem("userToken");
      
      if (userId && userToken && (!socket || !socket.connected)) {

        if (socket) {
          socket.disconnect();
        }
        socket = connectSocket();
      } else if (socket && socket.connected) {
        // If connected, stop checking
        clearInterval(checkInterval);
      }
    }, 2000); // Check every 2 seconds

    // Cleanup on unmount
    return () => {
      window.removeEventListener("storage", handleStorageChange);
      clearInterval(checkInterval);
      if (socket) {

        socket.disconnect();
      }
    };
  }, []);

  onMessageListener()
    .then((payload) => {

      const incomingTitle = payload?.notification?.title;
      const incomingBody = payload?.notification?.body;
      if (!incomingTitle && !incomingBody) {
        // Ignore empty notifications to avoid blank popups
        return;
      }
      setOpen(true);
      setNotification({
        title: incomingTitle,
        body: incomingBody,
      });
      setNotificationData(payload?.data);

    })
    .catch((err) => {
      // Error handled
    });

  return (
    (open && (notification?.title || notification?.body)) ? (
      <NitificationPopUp
        data={notificationData}
        notification={notification}
        open={open}
        setOpen={setOpen}
      />
    ) : null
  );
};

export default Notification;
